export default __webpack_public_path__ + "static/media/Flag of Dhekelia.d698ddf1.gif";